module.exports = __webpack_public_path__ + "img/sobre-nosotros-icon.0bc71fa9.svg";